import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ICampaignDetails } from '../../../../shared/models/campaign-details.model';
import { AccordionModule } from 'primeng/accordion';
import { InformationEntityComponent } from '../../../../shared/components/information-entity/information-entity.component';

@Component({
  selector: 'cv-campaign-details',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  styles: `
    .p-accordion .p-accordion-content.info-card .ad-source {
      flex: 0 1 100%;
    }
  `,
  imports: [AccordionModule, InformationEntityComponent],
  template: `
    <p-accordionTab [selected]="true" contentStyleClass="info-card" header="Campaign Details">
      <cv-information-entity class="ad-source" label="Ad Source" [value]="data.adsourceName" />
      <cv-information-entity label="Category" [value]="data.categoryTypeName" />
      <cv-information-entity label="Campaign" [value]="data.campaignName" />
      <cv-information-entity label="Details" [value]="data.details" />
    </p-accordionTab>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignDetailsComponent {
  @Input({ required: true }) data!: ICampaignDetails;
}
